import { isValidLandingPageUrl } from '@provision/landing-page-utils';

/** Blank is allowed, so an image or video can be removed. */
export const URL_FIELD_RULES = {
  validate: (value: unknown) => {
    const url = String(value ?? '').trim();
    return !url || isValidLandingPageUrl(url) || 'Enter a valid URL (https://…)';
  },
};
